import React from 'react';
import { useQuery } from '@apollo/client';
import { LOGGED_IN_CARDS_PER_PAGE } from '@/config';
import { RECOMMENDED_COMPANIES_QUERY } from '@/graphql/queries';
import { Maybe } from '@/types/graphql-types';

const useRecommendedCompanies = ({ first = LOGGED_IN_CARDS_PER_PAGE } = {}) => {
  let variables = { first };
  const { error, fetchMore, ...rest } = useQuery(RECOMMENDED_COMPANIES_QUERY, {
    variables,
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
  });

  const pagination = async (
    endCursor: Maybe<string>,
    deletedCompanies: number,
    setDeletedCompanies: React.Dispatch<React.SetStateAction<number>>,
  ) => {
    variables = { first: first + deletedCompanies };

    await fetchMore({
      variables: {
        ...variables,
        after: endCursor,
      },
    });
    setDeletedCompanies(0);
  };

  return {
    pagination,
    error,
    ...rest,
  };
};

export { useRecommendedCompanies };
